export default __webpack_public_path__ + "static/customer_sprague_thumb_1-68cac002a25f5a82ccc49d17679379f9.png";